/** Algolia facet attribute. Display copy comes from Search.filterCategories.partner. */
export const PARTNER_FILTER_CATEGORY = "partner";

export const ALL_TAB_TITLE = "All";
export const MAX_TAB_PRODUCT_LIMIT = 20;
export const DEFAULT_TAB_PRODUCT_LIMIT = MAX_TAB_PRODUCT_LIMIT;
export const ALL_TAB_PAGE_SIZE = 20;
export const DEFAULT_DAYS_AGO = 30;
export const NEW_BADGE_MAX_AGE_DAYS = 90;
